export const TRACKIMO = {
    title: 'TRACKIMO',
    brandName: 'Trackimo+',
    primaryColor: '#1976d2',
    androidAppLink: 'https://play.google.com/store/apps/details?id=com.trackimo.app2',
    iosAppLink: 'https://apps.apple.com/us/app/trackimo/id1515561581',
    localizeLink: 'https://trackimo-web-plus-translations.s3.us-west-2.amazonaws.com/locale/',
};
